var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFatigueAssessmentFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.645,
    height: 57.335,
    viewBox: "0 0 47.645 57.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H5.833V5.833H0z",
    transform: "translate(-388 -22) translate(394.894 34.727) translate(0 10.076)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.743V5.833H0z",
    transform: "translate(-388 -22) translate(394.894 34.727) translate(0 10.076) translate(11.136)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H5.833V5.833H0z",
    transform: "translate(-388 -22) translate(394.894 34.727) translate(0 20.151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.743V5.833H0z",
    transform: "translate(-388 -22) translate(394.894 34.727) translate(0 20.151) translate(11.136)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H5.833V5.833H0z",
    transform: "translate(-388 -22) translate(394.894 34.727)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.743V5.833H0z",
    transform: "translate(-388 -22) translate(394.894 34.727) translate(11.136)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H5.833V5.833H0z",
    transform: "translate(-388 -22) translate(394.894 34.727) translate(0 30.228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.743V5.833H0z",
    transform: "translate(-388 -22) translate(394.894 34.727) translate(0 30.228) translate(11.136)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M46.644 57.335H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h45.644a1 1 0 0 1 1 1v55.335a1 1 0 0 1-1 1zM2.826 6.46v47.645h41.589V6.46z",
    transform: "translate(-388 -22) translate(388 22)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFatigueAssessmentFilled);
export default __webpack_public_path__ + "static/media/fatigue-assessment-filled.4d18df8d729fd8a217e111c165e99930.svg";
export { ForwardRef as ReactComponent };